export default __webpack_public_path__ + "static/ESITCParis1-735658f90db89ed737c714f46d312049.png";